/**
 * Story Chapters — AARKA
 * Stacked sticky cards with GSAP ScrollTrigger snap.
 * Each chapter pins in place and the next slides up to cover it.
 * Scroll snaps to each chapter for a clean card-by-card experience.
 *
 * Note: This section uses CSS position:sticky (not GSAP pin).
 * Each chapter is 100vh in the DOM, so total section height = N × 100vh.
 * ScrollTrigger range = (N-1) × 100vh.
 * Snap interval = 1/(N-1) to hit each card boundary: 0, 1/(N-1), 2/(N-1), ..., 1.
 */
if (!customElements.get('aarka-story-chapters')) {
  customElements.define('aarka-story-chapters', class extends HTMLElement {

    connectedCallback() {
      if (window.AARKA && window.AARKA.ready) {
        this.init();
      } else {
        document.addEventListener('aarka:scroll-ready', () => this.init(), { once: true });
      }
    }

    disconnectedCallback() {
      if (this.st) this.st.kill();
      if (this.hintSt) this.hintSt.kill();
      if (this.observer) this.observer.disconnect();
    }

    init() {
      var gsap = window.AARKA.gsap;
      var ScrollTrigger = window.AARKA.ScrollTrigger;

      this.chapters = Array.from(this.querySelectorAll('.stc-chapter'));
      this.section = this.querySelector('.stc-section');
      var totalChapters = this.chapters.length;

      if (!this.section || totalChapters === 0) return;

      // Reveal text content when chapter is in view
      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('stc-chapter--visible', entry.isIntersecting);
          });
        },
        { threshold: 0.15 }
      );

      this.chapters.forEach(function (ch) {
        this.observer.observe(ch);
      }.bind(this));

      // ScrollTrigger for snapping between chapters (no pin — CSS sticky handles that)
      // Snap interval = 1/(N-1) aligns with card boundaries in the scroll range
      this.st = ScrollTrigger.create({
        trigger: this.section,
        start: 'top top',
        end: 'bottom bottom',
        snap: {
          snapTo: 1 / (totalChapters - 1),
          duration: { min: 0.2, max: 0.5 },
          delay: 0.05,
          ease: 'power1.inOut',
          inertia: false
        }
      });

      // Hide scroll hint after first scroll
      var hint = this.querySelector('.stc-scroll-hint');
      if (hint) {
        this.hintSt = ScrollTrigger.create({
          trigger: this.section,
          start: 'top top-=80',
          onEnter: function () {
            hint.style.opacity = '0';
            hint.style.pointerEvents = 'none';
          }
        });
      }
    }
  });
}
